export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Property Management", to: "/property-management" },
  { label: "Our Partners", to: "/partners" },
  { label: "Contact Us", to: "/contact" },
];

export const SERVICES = [
  {
    n: "01",
    title: "Tenant Placement & Lease Administration",
    body: "Rigorous tenant screening, competitive market positioning, and thorough lease documentation. We secure quality tenants who respect your property as much as you do.",
  },
  {
    n: "02",
    title: "Healthy Homes Standards Compliance",
    body: "Stay ahead of the Healthy Homes Standards with comprehensive audits, targeted upgrades, and meticulous documentation. Meet every deadline without the administrative burden.",
  },
  {
    n: "03",
    title: "Financial Reporting & Performance",
    body: "Monthly detailed statements, expense tracking, and analytical insights into property performance. Our financial discipline reflects backgrounds in financial services and business development.",
  },
  {
    n: "04",
    title: "Property Manager Licensing",
    body: "Full compliance with NZ Property Manager licensing requirements. We stay current on regulatory changes, so you don't have to.",
  },
  {
    n: "05",
    title: "Maintenance Coordination",
    body: "Proactive maintenance coordination and rapid response to tenant needs. Trusted contractors, quality workmanship, and transparent cost management.",
  },
  {
    n: "06",
    title: "Ongoing Communication",
    body: "Personalised reporting and proactive communication. You receive clear, timely updates on what matters, not a monthly form email.",
  },
];

export const STATS = [
  { value: "100%", label: "Compliant", sub: "Healthy Homes Standards" },
  { value: "0", label: "Tenant placement fees", sub: "included in management" },
  { value: "< 24h", label: "Response time", sub: "to tenant enquiries" },
];

export const PILLARS = [
  {
    n: "01",
    title: "Financial discipline",
    body: "Transparent reporting that shows exactly how the asset is performing, no surprises. Rigorous budgeting, meticulous costing, and analytical insight applied to every property.",
  },
  {
    n: "02",
    title: "Proactive compliance",
    body: "Healthy Homes and licensing obligations managed ahead of the deadline, not after it. Every regulatory change is tracked so you stay ahead without lifting a finger.",
  },
  {
    n: "03",
    title: "Owner-first support",
    body: "Built for time-poor owners, every service removes a decision rather than adding one. We operate as an extension of your team so ownership stays genuinely hands-off.",
  },
];

export const IMAGES = {
  heroExterior: "https://images.unsplash.com/photo-1613490493576-7fde63acd811",
  marble: "https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg",
  whiteHouse: "https://images.pexels.com/photos/30211366/pexels-photo-30211366.jpeg",
  professional: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
  livingRoom: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c",
};

export const CONTACT = {
  phone: "0800 546 558",
  email: "info@keptproperty.co.nz",
  location: "New Zealand, Serving property owners nationwide",
};

export const PM_SERVICES = [
  {
    n: "01",
    title: "Free Rental Appraisal",
    body: "Our complimentary rental appraisal pairs hands-on experience managing properties across Auckland with a deep pool of market data, so you understand exactly what your investment should return. The rental market is difficult to read on your own; that is where we come in. You receive a considered, personalised assessment of your property's rental potential, and a clear first step toward optimising it.",
  },
  {
    n: "02",
    title: "Tenant Screening & Onboarding",
    body: "Choosing the right tenant is one of the most important decisions in protecting your property. We follow a careful, evidence-based screening process that minimises risk, reduces vacancies, and secures stable tenancies. From reviewing applications and verifying details to preparing compliant tenancy agreements and coordinating a smooth move-in, we manage the full onboarding, setting clear expectations from day one.",
  },
  {
    n: "03",
    title: "Property Maintenance & Repairs",
    body: "We take a proactive approach to maintenance and repairs, protecting your property's value and keeping tenants satisfied. From routine upkeep to urgent issues, we coordinate trusted contractors and hold every job to a high standard. With clear communication and timely action, your property stays compliant, well-maintained, and performing at its best.",
  },
  {
    n: "04",
    title: "Rent Collection & Financial Reporting",
    body: "Consistent rent collection and transparent reporting keep your income organised and reliable. Using secure systems, we collect rent on time, minimise delays, and provide clear, easy-to-read statements, so you can track income, expenses, and overall performance with confidence. Your rental income is handled professionally, accurately, and with complete transparency.",
  },
  {
    n: "05",
    title: "Rental Management",
    body: "Effective rental management protects your investment and supports stable, long-term tenancies. We manage every aspect of your property, tenant relationships, lease agreements, renewals, and ongoing communication. A proactive approach and early issue resolution keep day-to-day operations smooth and disruptions rare, so ownership stays genuinely hands-off.",
  },
  {
    n: "06",
    title: "Property Marketing",
    body: "Considered marketing attracts the right tenants and reduces vacancy. We present your property professionally and competitively, with clear, compelling listings that highlight its best features across the platforms that matter. The result is stronger enquiry, better tenant quality, and a smooth transition from listing to tenancy.",
  },
  {
    n: "07",
    title: "Healthy Homes Compliance",
    body: "Meeting Healthy Homes Standards protects both tenants and owners. We assess your property thoroughly, identify the improvements required, and guide you through the process so compliance stays simple and stress-free. You can feel confident your property meets current requirements and is maintained to a healthy, compliant standard.",
  },
];

export const PARTNER_LIST = [
  {
    name: "Finance Link",
    url: "https://www.financelink.co.nz",
    display: "financelink.co.nz",
    role: "Mortgage & financial advice",
  },
  {
    name: "Morrison & Associates",
    url: "https://m-a.co.nz/",
    display: "m-a.co.nz",
    role: "Accounting & advisory",
  },
  {
    name: "NZ Sure",
    url: "https://nzsure.co.nz/",
    display: "nzsure.co.nz",
    role: "Insurance & protection",
  },
];
